$(function() {
  $('input[type="submit"]:data(confirm)').on('click', function(e) {
    return confirm($(this).data('confirm'))
  })

  $(".select-all-cities").change(function() {
    const select = $(".select-cities")
    const checked = this.checked

    $(select).val(null)
    $(select).trigger('change')

    if(checked) {
      const allValues = $(select).find('option').map(function() {
        return $(this).val()
      }).get()

      $(select).val(allValues)
    }
  })

  $(".select-payment-option").change(function() {
    let input = $(".select-external-url")[0]
    const value = this.value
    const is_pharmiq = value == "pharmiq"

    input.disabled = is_pharmiq
  })
})
